import Cookies from "js-cookie";
import {useLocation, useNavigate} from "react-router-dom";
import {routes, useGetDataUpdateAsset, usePatchData} from "../routes/api";
import React, {useEffect, useLayoutEffect, useState} from "react";
import {Autocomplete, Grid} from "@mui/material";
import {organizationFields} from "../util/modelFields";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import {LoadingComponent} from "../util/loading";
import Button from "@mui/material/Button";


export default function OrganizationRelationEdit({orgData, id, refresh}) {
    const token = Cookies.get('token');
    const webAdmin = Cookies.get('webAdmin') === 'T';
    const route = routes.organization;

    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from ? location.state.from : {pathname: `/organization`};

    const [orgFormData, setOrgFormData] = useState(orgData.reduce((acc, item) => ({
        ...acc,
        [organizationFields.relations[item.type].alias]: item.id
    }), {}));
    const [openStates, setOpenStates] = useState(Object.values(organizationFields.relations).reduce(
        (acc, item) => ({...acc, [item.alias]: false}), {})
    );

    const {
        data: patchResp,
        statusCode: patchStatus,
        handleCall: handlePatch
    } = usePatchData(token, route, id);


    const {data: content, loading, handleCall} = useGetDataUpdateAsset(token, route, id);

    const fetchData = async () => {
        try {
            await handleCall();
        } catch (error) {
            console.error('Error fetching create asset:', error);
        }
    }
    useEffect(() => {
        fetchData();
    }, []);


    const handleChange = (newValue, key) => {
        setOrgFormData({
            ...orgFormData,
            [key]: newValue.map((item) => item[0])
        });
    }

    const getValue = (options, key) => {
        let value;
        if (!orgFormData[key]) {
            value = [];
        } else {
            value = orgFormData[key].map(item => options.find(option => option[0] === item)).filter(item => item);
        }
        return value;
    }

    const handleSubmit = () => {
        handlePatch({body: orgFormData});
    };

    useEffect(() => {
        if (patchStatus >= 200 && patchStatus < 300) {
            refresh();
        } else if (patchStatus > 300) {
            // const errors = isDict(patchResp) ? Object.keys(patchResp) : [];
            // const userErrors = errors.includes('a_user') && isDict(patchResp.a_user) ? Object.keys(patchResp.a_user) : [];
            // setErrorFields([...errors, ...userErrors].filter(item => item !== 'a_user'));
        }
    }, [patchStatus, patchResp]);


    useLayoutEffect(() => {
        if (!webAdmin) {
            navigate(from);
        }
    }, []);

    if (!webAdmin) navigate(from);
    if (loading) return <LoadingComponent/>

    return (
        <Grid
            container
            spacing={2}
            alignItems="stretch"
            justifyContent="center"
            sx={{margin: 'auto'}}
        >
            {Object.values(organizationFields.relations).filter(item => item.edit !== false).map(
                relation => (<>
                        <Grid size={5} key={`${relation.alias}-select`}
                              sx={{mb: 2, display: 'flex', alignItems: "flex-start"}}>
                            <Autocomplete
                                fullWidth
                                id={relation.alias}
                                open={openStates[relation.alias] || false}
                                onOpen={
                                    () => setOpenStates((states) => ({...states, [relation.alias]: true}))
                                }
                                onClose={
                                    () => setOpenStates((states) => ({...states, [relation.alias]: false}))
                                }
                                label={relation.alias}
                                name={relation.alias}
                                value={getValue(content[relation.alias].data, relation.alias)}
                                filterSelectedOptions
                                isOptionEqualToValue={(option, v) => option[0] === v[0]}
                                getOptionLabel={(option) => option[1]}
                                getOptionKey={(option) => option[0]}
                                options={content[relation.alias].data}
                                onChange={(e, newValue) => {
                                    handleChange(newValue, relation.alias);
                                }}
                                loading={loading}
                                multiple={relation.multiple}
                                disableCloseOnSelect={relation.multiple}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label={relation.display}
                                        slotProps={{
                                            input: {
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <>
                                                        {loading ? <CircularProgress color="inherit" size={20}/> : null}
                                                        {params.InputProps.endAdornment}
                                                    </>
                                                ),
                                            }
                                        }}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid size='grow' key={`${relation.alias}-filler`}/>
                    </>
                )
            )}
            <Grid size={12}>
                <Button component="label"
                        variant="contained"
                        onClick={handleSubmit}
                        sx={{margin: 2}}>
                    Save
                </Button>
            </Grid>
        </Grid>
    );
}